import { useModelLoader } from '@spazious/dollhouse-engine';
import { FShallowNodeTypesEnum } from '@spazious/dollhouse-shallow-graph';

import {
  useCollider,
  useFurnitureResolver,
  useLayers,
  useOverridedNodeProps,
} from '../../hooks/index.js';
import { FurnitureNode } from '../../types/node.js';

export type FurnitureProps = Optional<
  Omit<
    GraphNodeProps<FurnitureNode>,
    'name' | 'url' | 'furnitureType' | 'object' | 'collider' | 'collisions' | 'outline2D'
  >,
  'originator'
>;

export const Furniture: React.FC<FurnitureProps> = (props) => {
  const layers = useLayers();
  const overridedProps = useOverridedNodeProps(props);

  const { id, originator, ...restProps } = overridedProps;
  const { url, name, furnitureType } = useFurnitureResolver(id);
  const { scene } = useModelLoader(url);
  const { setRef, collider, collisions, posY } = useCollider(scene, true);

  return (
    <furniture
      ref={setRef}
      id={id}
      {...restProps}
      collider={collider}
      collisions={collisions}
      furnitureType={furnitureType}
      name={name}
      object={scene}
      originator={originator ?? null}
      positionY={posY || restProps.positionY || originator?.positionY || 0}
      url={url}
      visible={props.visible !== false && layers.isEnabled(FShallowNodeTypesEnum.Furniture)}
    />
  );
};
